export function randomHash() {
  const pattern = '0123456789abcdef';
  const values = [];

  for (let i = 0; i < 32; i++) {
    values[i] = pattern.substr(Math.floor(Math.random() * pattern.length), 1);
  }

  return values.join('');
}
